import { AppLayout } from "./layout/appLayout";
import { NotificationContextProvider } from "./core/context/notificationContextProvider";
import { BrowserRouter } from "react-router-dom";
import "rsuite/dist/rsuite.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.scss";

function App() {
  return (
    <BrowserRouter>
      <NotificationContextProvider>
        <AppLayout />
      </NotificationContextProvider>
    </BrowserRouter>
  );
}

export default App;
